import { createRouter, createWebHistory, Router } from "vue-router";

const router: Router = createRouter({
  scrollBehavior(to, from) {
    if (to.hash) {
      return {
        el: to.hash,
        top: 140,
        behavior: "smooth",
      };
    }

    if (from.name !== to.name) {
      return { top: 0 };
    }
  },
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/:pathMatch(.*)*",
      component: () => import("@/views/HomePage.vue"),
      beforeEnter: (to, from, next) => {
        next({ name: "HomeView" });
      },
    },

    {
      path: "",
      component: () => import("@/layouts/MainLayout.vue"),
      children: [
        {
          path: "",
          name: "HomeView",
          component: () => import("@/views/HomePage.vue"),
          meta: {
            header: "show",
            footer: "show",
          },
        },

        {
          path: "webinar/:id",
          name: "WebinarView",
          component: () => import("@/views/WebinarPage.vue"),
          meta: {
            header: "show",
            footer: "show",
          },
        },

        {
          path: "room/:id",
          name: "RoomView",
          component: () => import("@/views/RoomPage.vue"),
        },
      ],
    },

    {
      path: "/panel",
      component: () => import("@/layouts/PanelLayout.vue"),
      beforeEnter: (to, from, next) => {
        if (!localStorage.rcShowToken) {
          next({ name: "HomeView" });
          return;
        }

        next();
      },
      children: [
        {
          path: "",
          name: "PanelView",
          component: () => import("@/views/Panel/PanelWebinarsPage.vue"),
          meta: {
            header: "show",
          },
        },
        {
          path: "create",
          name: "CreateWebinarView",
          component: () => import("@/views/Panel/PanelCreateEventPage.vue"),
          meta: {
            header: "show",
          },
        },
        {
          path: "webinar/:id",
          name: "PanelWebinarView",
          component: () => import("@/views/Panel/PanelWebinarPage.vue"),
          meta: {
            header: "show",
          },
        },
      ],
    },
  ],
});

router.beforeEach((to) => {
  // const mainStore = useMainStore(); //pinia указывается тут

  // if (!mainStore.isAuthorized && to.name !== "Authorization") {
  //   return { name: "Authorization" };
  // }

  // @ts-ignore
  document.title = to.meta.title ?? window.document.title;
});

export default router;
